"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var v4_1 = __importDefault(require("uuid/v4"));

var types_1 = require("../types");

var Entity_1 = require("./Entity");

var PolyTransaction_1 = require("./PolyTransaction");

var PostTransactionResolver_1 = require("../PostTransactionResolver");

var utils_1 = require("../utils");

var PolymathError_1 = require("../PolymathError");

var Events;

(function (Events) {
  Events["StatusChange"] = "StatusChange";
  Events["TransactionStatusChange"] = "TransactionStatusChange";
})(Events || (Events = {}));
/**
 * Class to manage procedural transaction queues
 */


var TransactionQueue =
/*#__PURE__*/
function (_Entity_1$Entity) {
  _inherits(TransactionQueue, _Entity_1$Entity);

  /**
   * Create a transaction queue
   *
   * @param transactions - list of transactions to be run in this queue
   * @param returnValue - value that will be returned by the queue after it is run. It can be a Post Transaction Resolver
   * @param args - arguments with which the Procedure that generated this queue was instanced
   */
  function TransactionQueue(transactions, fees, returnValue, args) {
    var _this;

    var procedureType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : types_1.ProcedureType.UnnamedProcedure;

    _classCallCheck(this, TransactionQueue);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransactionQueue).call(this));
    /**
     * type of entity
     */

    _this.entityType = 'transactionQueue';
    /**
     * status of the transaction queue
     */

    _this.status = types_1.TransactionQueueStatus.Idle;
    /**
     * @hidden
     */

    _this.queue = [];
    /**
     * Run the transactions in the queue
     */

    _this.run = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _returnValue, res;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.queue = _toConsumableArray(this.transactions);
                this.updateStatus(types_1.TransactionQueueStatus.Running);
                _context.prev = 2;
                _context.next = 5;
                return this.executeTransactionQueue();

              case 5:
                this.updateStatus(types_1.TransactionQueueStatus.Succeeded);
                _returnValue = this.returnValue;

                if (PostTransactionResolver_1.isPostTransactionResolver(_returnValue)) {
                  res = _returnValue.result;
                } else {
                  res = _returnValue;
                }

                this.resolve(res);
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);
                this.error = _context.t0;
                this.updateStatus(types_1.TransactionQueueStatus.Failed);
                this.reject(_context.t0);

              case 16:
                return _context.abrupt("return", this.promise);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 11]]);
      }));
    };
    /**
     * @hidden
     */


    _this.resolve = function () {};
    /**
     * @hidden
     */


    _this.reject = function () {};
    /**
     * @hidden
     */


    _this.updateStatus = function (status) {
      _this.status = status;

      switch (status) {
        case types_1.TransactionQueueStatus.Running:
          {
            _this.emitter.emit(Events.StatusChange, _assertThisInitialized(_this));

            return;
          }

        case types_1.TransactionQueueStatus.Succeeded:
          {
            _this.emitter.emit(Events.StatusChange, _assertThisInitialized(_this));

            return;
          }

        case types_1.TransactionQueueStatus.Failed:
          {
            _this.emitter.emit(Events.StatusChange, _assertThisInitialized(_this), _this.error);

            return;
          }

        default:
          {
            throw new PolymathError_1.PolymathError({
              code: types_1.ErrorCode.FatalError,
              message: "Unknown Transaction Queue status: ".concat(status)
            });
          }
      }
    };

    _this.emitter = new events_1.EventEmitter();
    _this.procedureType = procedureType;
    _this.promise = new Promise(function (res, rej) {
      _this.resolve = res;
      _this.reject = rej;
    });
    _this.args = args;
    _this.fees = fees;
    _this.returnValue = returnValue;
    _this.transactions = transactions.map(function (transaction) {
      var txn = new PolyTransaction_1.PolyTransaction(transaction, _assertThisInitialized(_this));
      txn.onStatusChange(function (updatedTransaction) {
        _this.emitter.emit(Events.TransactionStatusChange, updatedTransaction, _assertThisInitialized(_this));
      });
      return txn;
    });
    _this.uid = TransactionQueue.generateId();
    return _this;
  }
  /**
   * Generate UUID for this Transaction Queue
   */


  _createClass(TransactionQueue, [{
    key: "toPojo",

    /**
     * Convert entity to a POJO (Plain Old Javascript Object)
     */
    value: function toPojo() {
      var uid = this.uid,
          transactions = this.transactions,
          status = this.status,
          procedureType = this.procedureType,
          args = this.args,
          fees = this.fees;
      return {
        uid: uid,
        transactions: transactions.map(function (transaction) {
          return transaction.toPojo();
        }),
        status: status,
        fees: fees,
        procedureType: procedureType,
        args: args
      };
    }
    /**
     * Subscribe to status changes on the Transaction Queue
     *
     * @param listener - callback function that will be called whenever the Transaction Queue's status changes
     *
     * @returns unsubscribe function
     */

  }, {
    key: "onStatusChange",
    value: function onStatusChange(listener) {
      var _this2 = this;

      this.emitter.on(Events.StatusChange, listener);
      return function () {
        _this2.emitter.removeListener(Events.StatusChange, listener);
      };
    }
    /**
     * Subscribe to status changes on individual transactions
     *
     * @param listener - callback function that will be called whenever the individual transaction's status changes
     *
     * @returns unsubscribe function
     */

  }, {
    key: "onTransactionStatusChange",
    value: function onTransactionStatusChange(listener) {
      var _this3 = this;

      this.emitter.on(Events.TransactionStatusChange, listener);
      return function () {
        _this3.emitter.removeListener(Events.TransactionStatusChange, listener);
      };
    }
    /**
     * @hidden
     */

  }, {
    key: "executeTransactionQueue",
    value: function executeTransactionQueue() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var nextTransaction;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                nextTransaction = this.queue.shift();

                if (nextTransaction) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                _context2.next = 5;
                return nextTransaction.run();

              case 5:
                _context2.next = 7;
                return this.executeTransactionQueue();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Hydrate the entity
     */

  }, {
    key: "_refresh",
    value: function _refresh() {}
  }], [{
    key: "generateId",
    value: function generateId() {
      return utils_1.serialize('transactionQueue', {
        random: v4_1.default()
      });
    }
  }]);

  return TransactionQueue;
}(Entity_1.Entity);

exports.TransactionQueue = TransactionQueue;